<template>

<v-card flat dark v-bind="$attrs" :color="inactive ? 'grey':menu.color" nuxt @click="select" v-if="menu">
                                  <v-img
                                  :src="require('../assets/bg-card.png')" 
                                    class="white--text"
                                    :class="{'text-center': vertical, 'pb-5': !vertical}"
                                    gradients="to top left, rgba(255,255,255,0.1), rgba(255,255,255,0.2)"
                                    :gradientss="getGradient(menu.color)"
                                  >
                                         <v-btn icon v-if="more && $listeners.more" dark class="mt-4 mr-4" style="float:right"><v-icon >expand_more</v-icon></v-btn>
                                         <v-icon size="32" dark v-text="menu.icon" :class="{'mt-4 pl-5': !vertical}" :style="vertical ? null : 'float:left'"></v-icon>
                                          <v-card-title v-text="menu.title" :class="{'justify-center': vertical}"></v-card-title>
                                         <!--v-btn rounded class="mb-3">Zoek restaurant</v-btn-->
                                    
                                     
                                      <!--v-list-item-subtitle class="px-2 text-subtitle-1" v-if="menu.description" style="white-space:normal">{{menu.description}}</v-list-item-subtitle-->
                                  <slot>
                                   
                                  </slot>
                                  </v-img>

                                  
                                </v-card>
                                            
</template>
<script>
import { mapGetters } from 'vuex'
import cardItem from '@/modules/cardItem'
export default {
  mixins: [cardItem],
   props: {
    type: {
      type: String,
      default: function () {
        return null
      },
    },
    inactive: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    vertical: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    more : {
      type: Boolean,
      default: function () {
        return false
      },
    }
   },
  data: () => ({
     
  }),
  computed: {
    ...mapGetters(['hub']),
    menu(){
      return this.$config.menu[this.type]
    },
    hasContent(){
      return this.$slots.default ? true : false
    }
  },
  mounted () {
  },
watch: {

},
methods: {
  showMore(){
    this.$emit('more',this.type)
  },
  select(){
    if (this.more) this.$emit('more',this.type)
    this.$emit('select',this.type)
  }
}
}

</script>
